// состояния страницы авторизации
export const LOGIN_STATUSES = {
  loadScreen: 0,
  loginScreen: 1,
  codeScreen: 2,
  userScreen: 3,
}
// состояния и классы "двойного" инпута
export const DOUBLE_INPUT_STATUSES = {
  init: 0,
  edit: 1,
  validate: 2,
  error: 3,
  success: 4,
}
export const DOUBLE_INPUT_CLASSES = ['', 'active', '', 'error', 'success']

// интервал ожидания возможности отправки нового кода (сек)
export const GET_NEW_CODE_DELAY = 30

// количество цифр в коде подтверждения авторизации
export const CODE_LENGTH = 4
